import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Link,
  Typography,
  useTheme,
} from "@mui/material";
import { ROUTES } from "consts";
import { useCheckViewPoint } from "hooks/useCheckViewPoint";
import { VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Divider from "v2/components/base/Divider/ui";
import { Col, Row } from "v2/components/base/Flex/ui";
import { ViewPoint } from "v2/components/base/ResponsiveLayout/ui";
import BasicButton from "v2/components/Buttons/BasicButton";

const CardGridLayout = ({ cardsConfig }: { cardsConfig: any[] }) => {
  const theme = useTheme();
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);
  return (
    <>
      <ViewPoint.Mobile>
        <Col type="cc" sx={{ gap: "24px" }} fullWidth>
          {cardsConfig.map((card) => (
            <CardComponent card={card} isMobile={isMobile} />
          ))}
        </Col>
      </ViewPoint.Mobile>
      <ViewPoint.Desktop>
        <Row
          sx={{
            flexWrap: "wrap",
            gap: "24px",
            marginX: "auto",
            padding: "8px",
          }}
          fullWidth>
          {cardsConfig.map((card) => (
            <CardComponent card={card} isMobile={isMobile} />
          ))}
        </Row>
      </ViewPoint.Desktop>
    </>
  );
};

const CardComponent = ({ card, isMobile }: { card: any; isMobile: boolean }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };

  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const navigateTo = () => {
    if (card.isActive) {
      navigate(ROUTES.airdropGroup.replace(":projectId", card.id));
    }
  };

  return (
    <Card
      sx={{
        position: "relative",
        flex: "1 1 auto",
        width: "100%",
        maxWidth: isMobile ? "100%" : "290px",
        borderRadius: "24px",
        background: `${theme.palette.surface["container-bg"]}`,
        transform: isHover && !isMobile ? "scale(1.02)" : "scale(1)",
        transition: "transform 0.2s ease-in-out",
        boxShadow: isHover && !isMobile ? "0px 0px 8px 0px #FFFFFF" : "none",
        border: card.isActive
          ? isHover && !isMobile
            ? "2px solid #FFFFFF"
            : "2px solid #FFFFFFA0"
          : "2px solid #FFFFFF30",
      }}
      onClick={isMobile ? navigateTo : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      <Row
        type="cc"
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 1,
          background: `${theme.palette.surface.black}`,
          borderRadius: "24px",
          padding: "4px 8px",
          opacity: isHover && !isMobile ? 0.9 : isMobile && !card.isActive ? 0.7 : 0,
          pointerEvents: isHover && card.isActive ? "auto" : "none",
          transform: isHover && !isMobile ? "scale(1.02)" : "scale(1)",
          transition: "all 0.2s ease-in-out",
          cursor: isMobile ? "pointer" : "default",
        }}
        fullWidth
        fullHeight
        onClick={navigateTo}>
        <Row>
          <Typography variant="mobile-action-s-heavy">
            {card.isActive ? "View Leaderboard" : "Coming Soon"}
          </Typography>
        </Row>
      </Row>
      <CardMedia
        sx={{
          height: 140,
          ...(card.image || {
            background: `${theme.palette.surface["container-bg"]} no-repeat center center`,
            backgroundSize: "25%",
          }),
        }}
        image={card.image ?? "/logo192.png"}
        title={card.title ?? "???"}
      />
      <CardContent
        sx={{
          minHeight: "131px",
          background: `${theme.palette.surface["black"]}`,
        }}>
        <Col>
          <Typography gutterBottom variant="mobile-display-s">
            {card.title ?? "???"}
          </Typography>
          <Typography variant="mobile-body-s" color="text.secondary">
            {card.description ?? "Stay tuned."}
          </Typography>
        </Col>
      </CardContent>
    </Card>
  );
};

export default CardGridLayout;
